module.exports = __webpack_public_path__ + "static/mark_5-3383640cfb5873ac4a5000cc3ae1feee.png";